export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11487.08c63014.jpg";